import { render, staticRenderFns } from "./charge-by-otp-form.vue?vue&type=template&id=6893b8b5&"
import script from "./charge-by-otp-form.vue?vue&type=script&lang=js&"
export * from "./charge-by-otp-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports